import { render, staticRenderFns } from "./tenuta-san-guido.vue?vue&type=template&id=3119b09c&scoped=true"
import script from "./tenuta-san-guido.vue?vue&type=script&lang=js"
export * from "./tenuta-san-guido.vue?vue&type=script&lang=js"
import style0 from "./tenuta-san-guido.vue?vue&type=style&index=0&id=3119b09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119b09c",
  null
  
)

export default component.exports